import React from 'react';
import { Container } from './styles';

export default function NewOrder() {
  return (
    <main>
      <Container>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfeOGb_xmxEcnVbqGi6Gu1pbgflcsoqGn6CmpcrmpHB7-Vdtg/viewform?embedded=true"
          width="640"
          height="1968"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="form"
          id="form"
        >
          Loading…
        </iframe>
      </Container>
    </main>
  );
}
